import {apiGetDebtorsAndCreditors} from "api/reportApi";

import {CheckComponent, PriceComponent} from "components/Table/CellComponents";

const debtorsAndCreditorsColumns = [
    {
        name: "کد حسابداری",
        key: "accountingCode",
        filterParams: {
            column: "accountingCode",
            columnType: "string",
        },
    },
    {
        name: "دسته بندی",
        key: "Person_Type",
        filterParams: {
            column: "personType",
            columnType: "string",
        },
        searchType: "autocomplete",
        dataKey: {
            column: "personCategories",
            key: "title",
        },
    },
    {
        name: "نام",
        key: "firstName",
        filterParams: {
            column: "firstName",
            columnType: "string",
        },
        searchType: "autocomplete",
        dataKey: {
            column: "persons",
            key: "firstName",
        },
    },
    {
        name: "نام خانوادگی",
        key: "lastName",
        filterParams: {
            column: "lastName",
            columnType: "string",
        },
        searchType: "autocomplete",
        dataKey: {
            column: "persons",
            key: "lastName",
        },
    },
    {
        name: "نام نمایشی",
        key: "nickName",
        filterParams: {
            column: "nickName",
            columnType: "string",
        },
         navigate: "/reports/personalAccountCard?personId=",
        searchType: "autocomplete",
        dataKey: {
            column: "persons",
            key: "nickName",
        },
    },
    {
        name: "شماره همراه",
        key: "mobile",
        filterParams: {
            column: "mobile",
            columnType: "string",
        },
    },
    {
        name: "تامین کننده",
        key: "provider",
        Component: CheckComponent,
        // @ts-ignore
        getValue: (item) => {
            return item.formTypeTitle === "تامین کننده" ? item.formTypeTitle : "-";
        },
        disableSearch: true,
        searchType: "autocomplete",
        dataKey: {
            column: "persons",
            key: "nickName",
        },
    },
    {
        name: "مشتری",
        key: "customer",
        Component: CheckComponent,
        // @ts-ignore
        getValue: (item) => {
            return item.formTypeTitle === "مشتری" ? item.formTypeTitle : "-";
        },
        disableSearch: true,
        searchType: "autocomplete",
        dataKey: {
            column: "persons",
            key: "nickName",
        },
    },
    {
        name: "سهامدار",
        key: "shareholder",
        // @ts-ignore
        getValue: (item) => {
            return item.formTypeTitle === "سهامدار" ? item.formTypeTitle : "-";
        },
        disableSearch: true,
        searchType: "autocomplete",
        dataKey: {
            column: "persons",
            key: "nickName",
        },
    },
    {
        name: "بدهکار",
        key: "debtor",
        filterParams: {
            column: "debtor",
            columnType: "number",
        },
        getValue: (item: any) => item.debtor,
        Component: PriceComponent,
        // disableSearch: true,
        searchType: "quantitative",
    },
    {
        name: "بستانکار",
        key: "credit",
        filterParams: {
            column: "credit",
            columnType: "number",
        },
        // price: true,
        getValue: (item: any) => item.credit,
        Component: PriceComponent,
        // disableSearch: true,
        searchType: "quantitative",
    },
    {
        name: "تراز",
        key: "balance",
        filterParams: {
            column: "balance",
            columnType: "number",
        },
        // price: true,
        getValue: (item: any) => item.balance,
        Component: PriceComponent,
        searchType: "quantitative",
    },
    {
        name: "ماهیت",
        key: "debtorCreditor",
        // price: true,
        getValue: (item: any) => {
            const dif = item.credit - item.debtor;
            return dif === 0 ? "تراز" : dif > 0 ? "بس" : "بد";
        },
        disableSearch: true,
    },
];

export const debtorsAndCreditorsIndexData = [
    {
        key: "debtors",
        label: "مشتری",
        pluralLabel: "مشتریان",
        disableSearch: true,
        title: "مشتریان",
        pageTitle: "بدهکاران و بستانکاران",
        // pageDescription: "گزارش بدهکاران و بستانکاران کسب و کار",
        tableColumns: debtorsAndCreditorsColumns,
        actions: {
            back: {},
            fetch: apiGetDebtorsAndCreditors,
            // excel: {},
        },
    },
];
